export default __webpack_public_path__ + "static/media/101-northern-cyprus.5c1e67db.svg";